import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonRow,
} from '@ionic/react';
import { IAnnouncement } from '../../../lib/models';

const NewsCard = ({ announcement }: { announcement: IAnnouncement }) => {
  return (
    <IonCard key={announcement.id}>
      <img
        src={
          announcement.media?.data?.attributes?.url ||
          'https://dummyimage.com/640x360/fff/aaa'
        }
        alt={`${announcement.title}`}
      />
      <IonCardHeader>
        <IonCardTitle className='font-bold'>{announcement.title}</IonCardTitle>
        <IonCardSubtitle>
          <div className='font-bold'>
            {new Date(announcement?.publishedAt).toLocaleDateString()}
          </div>
        </IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent>{announcement.extract}</IonCardContent>
      <IonRow>
        <IonCol className='flex justify-end'>
          <IonButton routerLink={`/news/${announcement.id}`}>
            Dettagli
          </IonButton>
        </IonCol>
      </IonRow>
    </IonCard>
  );
};

export default NewsCard;
